import isEmpty from 'lodash.isempty';
import { connectedStore } from '../../store';
import globals from '../../globals';
import template from '../../template';
import constants from '../constants';
import getButtonPreset from '../selectors/button-preset';

const getCurrentButtonPreset = () => {
  const store = connectedStore.get();
  const state = store.getState();

  const buttonPresetVariables = template.selectors.getVariableValueByPath(
    state,
    constants.BUTTON_PRESET_VARIABLE
  );

  if (isEmpty(buttonPresetVariables)) return null;

  const variable = buttonPresetVariables.find((item) => item.querySelector);

  if (!variable) return null;

  const globalNode = globals.operations.extractGlobalContent(variable.globalId);

  if (!globalNode) return null;

  const element = globalNode.querySelector(variable.querySelector);

  if (!element) return null;

  const currentButtonPresetId = element.getAttribute(constants.BUTTON_PRESET_DATA_ATTRIBUTE);

  return getButtonPreset(state, currentButtonPresetId);
};

export default getCurrentButtonPreset;
